"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.billOfMaterials = billOfMaterials;
exports.opAmpSparesByPassCapacitors = opAmpSparesByPassCapacitors;
exports.referenceDesignator = referenceDesignator;
var _prettyNum = _interopRequireDefault(require("@ebiz/pretty-num"));
var _photodiodeConstants = _interopRequireDefault(require("./photodiode-constants"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function referenceDesignator(opAmp, name, value) {
  let refDesignator = "";
  switch (name) {
    case _photodiodeConstants.default.circuitComponents.Cf:
      {
        refDesignator = ["Cf", value + "F"];
        break;
      }
    case _photodiodeConstants.default.circuitComponents.Rf:
      {
        refDesignator = ["Rf", value + "\u2126"];
        break;
      }
    case _photodiodeConstants.default.circuitComponents.Rg2:
      {
        refDesignator = ["Rg2", value + "\u2126"];
        break;
      }
    case _photodiodeConstants.default.circuitComponents.Rf2:
      {
        refDesignator = ["Rf2", value + "\u2126"];
        break;
      }
    case _photodiodeConstants.default.circuitComponents.Cfilter:
      {
        refDesignator = ["Cfilter", value + "F"];
        break;
      }
    case _photodiodeConstants.default.circuitComponents.Rfilter:
      {
        refDesignator = ["Rfilter", value + "\u2126"];
        break;
      }
    case _photodiodeConstants.default.circuitComponents.D1:
      {
        refDesignator = ["D1", value];
        break;
      }
    case _photodiodeConstants.default.circuitComponents.OpAmp1:
      {
        if (opAmp.numberChannels && parseInt(opAmp.numberChannels) > 1) {
          refDesignator = ["1/" + opAmp.numberChannels + " " + value, "U1"];
        } else {
          refDesignator = [value, "U1"];
        }
        break;
      }
    case _photodiodeConstants.default.circuitComponents.OpAmp2:
      {
        if (opAmp.numberChannels && parseInt(opAmp.numberChannels) > 1) {
          refDesignator = ["1/" + opAmp.numberChannels + " " + value, "U2"];
        } else {
          refDesignator = [value, "U2"];
        }
        break;
      }
  }
  return refDesignator;
}
function opAmpSparesByPassCapacitors(stagesObject, stagesPreference) {
  let byPassCapacitors = new Array(),
    opAmpSpares = new Array(),
    tantCapacitors = new Array(),
    retObject = [];
  byPassCapacitors.push({
    name: "Cbp+",
    value: 100e-9,
    type: "positive"
  });
  byPassCapacitors.push({
    name: "Cbp-",
    value: 100e-9,
    type: "negative"
  });
  var opAmp1 = stagesObject.stage1.opAmp;

  // first stage op amp spares
  if (opAmp1.numberChannels > 1) {
    let len = opAmp1.numberChannels - 1;
    for (let i = 0; i < len; i++) {
      // add spare opAmp
      opAmpSpares.push({
        name: "U1",
        value: "1/" + opAmp1.numberChannels + " " + opAmp1.partNumber
      });
    }
  }

  // 2 stages
  if (stagesPreference == _photodiodeConstants.default.pdStages.twoStage) {
    let opAmp2 = stagesObject.stage2.opAmp;
    byPassCapacitors.push({
      name: "Cbp2+",
      value: 100e-9,
      type: "positive"
    });
    byPassCapacitors.push({
      name: "Cbp2-",
      value: 100e-9,
      type: "negative"
    });

    //If we are using the same part for each stage, then assume using the same package for each stage and remove the extra spares
    if (opAmp2.partNumber === opAmp1.partNumber) {
      opAmpSpares.pop();
    } else if (opAmp2.numberChannels > 1) {
      let len = opAmp2.numberChannels - 1;
      for (let i = 0; i < len; i++) {
        // add spare opAmp
        opAmpSpares.push({
          name: "U1",
          value: "1/" + opAmp2.numberChannels + " " + opAmp2.partNumber
        });
      }
    }
  }
  tantCapacitors.push({
    name: "Ctant+",
    value: 10e-6,
    type: "positive"
  });
  tantCapacitors.push({
    name: "Ctant-",
    value: 10e-6,
    type: "negative"
  });
  retObject = {
    opAmpSpares: opAmpSpares,
    byPassCapacitors: byPassCapacitors,
    tantCapacitors: tantCapacitors
  };
  return retObject;
}
function billOfMaterials(stagesObject, stagesPreference, sensor) {
  var billOfMaterialsResistorArray = new Array(),
    billOfMaterialsCapacitorArray = new Array(),
    billOfMaterialsOpAmpArray = new Array(),
    validCapacitors = new Array(),
    validResistors = new Array(),
    billOfMaterialArray = new Array(),
    resistorTable,
    capacitorTable,
    opAmpTable,
    byPassCapsSpareOpAmps,
    byPassCapacitors,
    tantCapacitors,
    resistorTolerance = '0.5%',
    capacitorTolerance = '5%',
    bypassCapacitorTolerance = '20%';

  // get capacitors and resitors for first stage
  validCapacitors.push({
    name: _photodiodeConstants.default.circuitComponents.Cf,
    value: stagesObject.stage1.cfext
  });
  validResistors.push({
    name: _photodiodeConstants.default.circuitComponents.Rf,
    value: stagesObject.stage1.rf
  });

  // get capacitors and resitors for second stage if there are 2 stages
  if (stagesPreference == _photodiodeConstants.default.pdStages.twoStage) {
    //if we are using a voltage follower for the 2nd stage, we don't want to print out rf2 or rg2
    if (stagesObject.stage2.rf !== 0) {
      validResistors.push({
        name: _photodiodeConstants.default.circuitComponents.Rg2,
        value: stagesObject.stage2.rg
      });
      validResistors.push({
        name: _photodiodeConstants.default.circuitComponents.Rf2,
        value: stagesObject.stage2.rf
      });
    }
    validCapacitors.push({
      name: _photodiodeConstants.default.circuitComponents.Cfilter,
      value: stagesObject.stage2.cfilter
    });
    if (stagesObject.stage2.rfilter != undefined) {
      validResistors.push({
        name: _photodiodeConstants.default.circuitComponents.Rfilter,
        value: stagesObject.stage2.rfilter
      });
    }
  }

  // get bill of materials object of all the resistors
  for (let j = 0; j < validResistors.length; j++) {
    let materialAndPackageResistor = materialAndPackageForResistors(resistorTolerance);
    billOfMaterialsResistorArray.push({
      refDesignator: validResistors[j].name,
      value: validResistors[j].value,
      prodURL: null,
      package: materialAndPackageResistor.package,
      material: materialAndPackageResistor.material,
      tolerance: resistorTolerance
    });
  }

  // get bill of materials object for all the capacitors 
  for (let k = 0; k < validCapacitors.length; k++) {
    // eslint-disable-next-line no-unused-vars
    let refDesignatorCapacitor = this.referenceDesignator(stagesObject.stage1.opAmp, validCapacitors[k].name, validCapacitors[k].value);
    let materialAndPackageCapacitor = materialAndPackageForCapacitors(validCapacitors[k].value, capacitorTolerance, false);
    billOfMaterialsCapacitorArray.push({
      refDesignator: validCapacitors[k].name,
      value: validCapacitors[k].value,
      prodURL: null,
      package: materialAndPackageCapacitor.package,
      material: materialAndPackageCapacitor.material,
      tolerance: capacitorTolerance
    });
  }

  // get the bill of materials object for first stage op amp
  let PackageAndMaterialsOpAmp1 = materialAndPackageForOpAmps(stagesObject.stage1.opAmp);
  billOfMaterialsOpAmpArray.push({
    refDesignator: 'U1',
    value: stagesObject.stage1.opAmp.partNumber,
    prodURL: stagesObject.stage1.opAmp.generic.toUpperCase() + ".html",
    package: PackageAndMaterialsOpAmp1.package,
    material: PackageAndMaterialsOpAmp1.material,
    tolerance: ""
  });
  if (stagesPreference == _photodiodeConstants.default.pdStages.twoStage) {
    // get the bill of materials object for second stage op amp
    let PackageAndMaterialsOpAmp2 = materialAndPackageForOpAmps(stagesObject.stage2.opAmp);
    billOfMaterialsOpAmpArray.push({
      refDesignator: 'U2',
      value: stagesObject.stage2.opAmp.partNumber,
      prodURL: stagesObject.stage2.opAmp.generic.toUpperCase() + ".html",
      package: PackageAndMaterialsOpAmp2.package,
      material: PackageAndMaterialsOpAmp2.material,
      tolerance: ""
    });
  }

  // get bypass capacitors
  byPassCapsSpareOpAmps = this.opAmpSparesByPassCapacitors(stagesObject, stagesPreference);
  byPassCapacitors = byPassCapsSpareOpAmps.byPassCapacitors;
  tantCapacitors = byPassCapsSpareOpAmps.tantCapacitors;

  //loop through byPass capacitors to get the bill of materials object
  for (let i = 0; i < byPassCapacitors.length; i++) {
    let byPassCapMaterialsAndPackage = materialAndPackageForCapacitors(byPassCapacitors[i].value, bypassCapacitorTolerance, false);
    //fix for if value is a engineering string, rather than number
    if (typeof byPassCapacitors[i].value === "string") {
      var bypassCapString = byPassCapacitors[i].value;
      bypassCapString = bypassCapString.slice(0, -1);
      byPassCapacitors[i].value = _prettyNum.default.userEntryToNumber(bypassCapString, "Engineering", 3)[0];
    }
    billOfMaterialsCapacitorArray.push({
      refDesignator: byPassCapacitors[i].name,
      value: byPassCapacitors[i].value,
      prodURL: null,
      package: byPassCapMaterialsAndPackage.package,
      material: byPassCapMaterialsAndPackage.material,
      tolerance: bypassCapacitorTolerance
    });
  }

  //loop through tantalum capacitors to get the bill of materials object
  for (let m = 0; m < tantCapacitors.length; m++) {
    //fix for if value is a engineering string, rather than number
    if (typeof tantCapacitors[m].value === "string") {
      let tantCapString = tantCapacitors[m].value;
      tantCapString = tantCapString.slice(0, -1);
      tantCapacitors[m].value = _prettyNum.default.userEntryToNumber(tantCapString, "Engineering", 3)[0];
    }
    billOfMaterialsCapacitorArray.push({
      refDesignator: tantCapacitors[m].name,
      value: tantCapacitors[m].value,
      prodURL: null,
      package: "6032",
      material: "tantalum",
      tolerance: "20%"
    });
  }

  // get the bill of materials object for photodiode/sensor
  let sensorValue = sensor == '' || sensor.length == 0 ? "Custom" : sensor;
  let billOfMaterialsSensor = {
    count: 1,
    designators: ['D1'],
    value: sensorValue,
    prodURL: null,
    package: "",
    tolerance: "",
    material: ""
  };

  // getting the bill Of Material grouping for resistor array table and adding the unit for resistors
  resistorTable = billOfMaterialsTable(billOfMaterialsResistorArray, true, "Ω");

  // getting the bill of Material grouping for capacitor array table and adding the unit for capacitors
  capacitorTable = billOfMaterialsTable(billOfMaterialsCapacitorArray, true, "F");

  // getting the bill of material grouping for opAmp table
  opAmpTable = billOfMaterialsTable(billOfMaterialsOpAmpArray, false, null);

  // add sensor to op amps table
  opAmpTable.push(billOfMaterialsSensor);

  // merge all objects into one final bill of materials object array
  billOfMaterialArray = resistorTable.concat(capacitorTable.concat(opAmpTable));
  return billOfMaterialArray;
}

//Private functions
function materialAndPackageForResistors(toleranceValue) {
  let pkg,
    material,
    retObject = [];
  if (toleranceValue <= _photodiodeConstants.default.resistorTolerance.fiveTenths) {
    pkg = "0603";
    material = "Thin Film";
  } else {
    pkg = "0603";
    material = "";
  }
  retObject = {
    package: pkg,
    material: material
  };
  return retObject;
}
function materialAndPackageForOpAmps(opAmp) {
  let pkg,
    material,
    retObject = [];
  material = "";
  pkg = "";
  if (opAmp.packageCode !== null && opAmp.packageCode.indexOf("R-8") != -1) {
    pkg = "SOIC";
  } else if (opAmp.packageCode !== null && opAmp.packageCode.indexOf("RM-8") != -1) {
    pkg = "MSOP";
  }
  retObject = {
    package: pkg,
    material: material
  };
  return retObject;
}
function materialAndPackageForCapacitors(value, toleranceValue, boolReferenceBoard) {
  var pkg = "",
    material = "",
    tolerance,
    retObject = [];

  //check if the tolerance is ideal and get the integer value of the tolerance to compare
  if (toleranceValue != _photodiodeConstants.default.capacitorTolerance.ideal) {
    tolerance = parseFloat(toleranceValue);
  }
  if (value <= 10 * 1e-9) {
    material = "C0G";
    pkg = "0603";
  } else if (value > 10 * 1e-9 && value <= 100 * 1e-9 && tolerance <= 10) {
    material = "C0G";
    pkg = "1206";
  } else if (value > 10 * 1e-9 && value <= 100 * 1e-9 && tolerance == 20) {
    material = "X7R";
    pkg = "0603";
  } else if (value > 100 * 1e-9 && value < 10 * 1e-6) {
    material = "X7R";
    pkg = "1206";
  } else if (value == 0.00001 && boolReferenceBoard == true) {
    material = "tantalum";
    pkg = "6032";
  }
  retObject = {
    package: pkg,
    material: material
  };
  return retObject;
}

// function groupBy(array, predicate) {
//     var grouped = {};
//     for (var i = 0; i < array.length; i++) {
//         var groupKey = predicate(array[i]);
//         if (typeof (grouped[groupKey]) === "undefined")
//             grouped[groupKey] = [];
//         grouped[groupKey].push(array[i]);
//     }

//     return grouped;
// }

function billOfMaterialsTable(array, formatValue, unit) {
  var billOfMaterialDisplay = new Array(),
    arrayNew = new Array(),
    arrayCount = new Array(),
    dlist = "",
    boolFound = false;
  for (let i = 0; i < array.length; i++) {
    let element = array[i];
    element.refDesignator = [element.refDesignator];
  }
  let arrayClone = {
    ...array[0]
  };

  // clone and push the first element of the array
  arrayNew.push(arrayClone);
  arrayCount.push(1);
  for (var b = 1; b < array.length; b++) {
    dlist = array[b].refDesignator;
    boolFound = false;

    // compare each element of array with the elements of arrayNew created
    for (var i = 0; i < arrayNew.length; i++) {
      if (array[b].value == arrayNew[i].value && array[b].tolerance == arrayNew[i].tolerance && array[b].package == arrayNew[i].package && array[b].material == arrayNew[i].material) {
        arrayNew[i].refDesignator = arrayNew[i].refDesignator.concat(dlist);
        if (array[b].count > 1) {
          arrayCount[i]++;
        }
        arrayCount[i]++;
        boolFound = true;
        break;
      }
    }

    // if boolFound is true, continue with the loop
    if (boolFound) continue;

    // if any element in from the array doesnt match with elements of arrayNew, clone and push it to arrayNew
    var tempObj = {
      ...array[b]
    };
    arrayNew.push(tempObj);
    arrayCount.push(1);
  }
  for (var j = 0; j < arrayNew.length; j++) {
    if (formatValue) {
      arrayNew[j].value = _prettyNum.default.numberToUserDisplay(arrayNew[j].value, "Engineering", 5, {
        supplySpace: true
      }) + unit;
    }

    // push the elements of arrayNew to billOfMaterialsDisplay
    billOfMaterialDisplay.push({
      count: arrayCount[j],
      designators: arrayNew[j].refDesignator,
      value: arrayNew[j].value,
      prodURL: arrayNew[j].prodURL,
      package: arrayNew[j].package,
      tolerance: arrayNew[j].tolerance,
      material: arrayNew[j].material
    });
  }
  return billOfMaterialDisplay;
}